module.exports = __webpack_public_path__ + "img/Jump Casting88.3607b207.jpg";